import { render, staticRenderFns } from "./decision-question.vue?vue&type=template&id=543dec86&scoped=true&"
import script from "./decision-question.vue?vue&type=script&lang=js&"
export * from "./decision-question.vue?vue&type=script&lang=js&"
import style0 from "./decision-question.vue?vue&type=style&index=0&id=543dec86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543dec86",
  null
  
)

export default component.exports